'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (inputValue, bridge) {
    return inputValue.split(bridge).map(function (obj) {
        switch (obj.length) {
            case 0:
                return '01';
            case 1:
                return '0' + (obj === '0' ? '1' : obj);
            default:
                return obj;
        }
    }).join(bridge);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/returnValidDate.js
// module id = 69
// module chunks = 0